import { Organization } from "generated/graphql";
import { Action } from "redux";

export type SelectOrganization = "SELECT_ORGANIZATION";
export const SELECT_ORGANIZATION: SelectOrganization = "SELECT_ORGANIZATION";

export interface SelectOrganizationAction extends Action {
    payload: {
        organization: Organization;
    };
    type: SelectOrganization;
}

export function selectOrganization(organization: Organization | undefined): SelectOrganizationAction {
    return {
        payload: {
            organization
        },
        type: SELECT_ORGANIZATION
    };
}
